<template>
  <div id="app" v-if="store.langLoaded">
    <router-view/>
  </div>
</template>

<script>
import store from '@/store'

export default {
  name: 'App',
  data() {
    return {
      store: store
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/App.vue